/*
 * This is a polyfill for our scroll-triggered animations that use two new browser features
 *
 * - scroll timeline
 * - container style queries
 *
 * Firefox and Safari do not support these for now => this polyfill
 *
 * @see https://caniuse.com/mdn-css_properties_scroll-timeline
 * @see https://caniuse.com/css-container-queries-style
 * @see /src/stylus/modules/_animations.styl
 */
const useOnRevealPolyfill = () => {
  const userAgent = window.navigator.userAgent.toLowerCase();
  const isSafari = userAgent.includes('applewebkit') && !userAgent.includes('chrome');

  if (!isSafari && CSS.supports('(animation-timeline: view())')) return;

  const observerHandler = entries => {
    entries.forEach(entry => {
      const el = entry.target;
      const isActive = el.classList.contains('is-animation-active');

      if (entry.isIntersecting) {
        if (isActive) return;

        el.style.setProperty('--reveal-animate', 'true');
        el.classList.add('is-animation-active');
      }
      else if (isActive) {
        if (entry.boundingClientRect.top < 0) return; // exit is from the top

        el.style.setProperty('--reveal-animate', 'false');
        el.classList.remove('is-animation-active');
      }
    });
  };

  const observer = new IntersectionObserver(observerHandler, { threshold: 0.17 });
  document.querySelectorAll('.OnReveal-item').forEach(item => observer.observe(item));
};

window.addEventListener('DOMContentLoaded', useOnRevealPolyfill);

